function rtus() {

    if (!!$('.preload').length) {
        setTimeout(function(){
            setTimeout(function() { $('#backto').removeClass('preload'); },1000);
        }, 1000);
    }

};